type TargetProps = {
  label: string;
  value: number | string;
  unit?: string;
  icon?: React.ReactNode;
};

export const Target = ({ label, value, unit, icon }: TargetProps) => {
  return (
    <div className="target-fixed-width py-2">
      <div className="d-flex align-items-center gap-3">
        <div>{icon ? icon : "image"}</div>
        <div
          className="fw-bold"
          style={{
            fontSize: "16px",
            lineHeight: "100%",
            fontWeight: 700,
            color: "#596699",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </div>
      </div>
      <div
        style={{
          fontWeight: 600,
          fontSize: "29px",
          lineHeight: "100%",
          letterSpacing: 0,
          display: "flex",
          color: "#596699",
          marginTop: "8px",
          marginLeft: "50px",
        }}
      >
        {value}
        {unit && <span className="ms-1">{unit}</span>}
      </div>
    </div>
  );
};
